import React, { useState } from 'react'

export default function LineUpAllHome() {
  const [Homerenk , Homesetrenk] = useState("#a41d34")
 
  return (
    <div className='TeamsHomeTeamKadro'>
       <div style={{background: ` ${Homerenk} `}} className='TeamsHomeTeamKadroHeader'><div className='TeamsHomeTeamKadroHomeTeamName'>Trabzonspor</div><div className='TeamsTeamKadroDizilis'>4-1-4-1</div></div>
       <div className='TeamsHomeTeamKadroAll'>
        <div className='wrapperLineUpAll'>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
          <div>Uğurcan</div>
        </div>
         </div>
   </div>
  )
}
